import { render, staticRenderFns } from "./checkBox.vue?vue&type=template&id=5d31e123"
import script from "./checkBox.vue?vue&type=script&lang=js"
export * from "./checkBox.vue?vue&type=script&lang=js"
import style0 from "./checkBox.vue?vue&type=style&index=0&id=5d31e123&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports